<script lang="ts">
  import { t } from 'svelte-i18n';
  import Button from '../shared/button.svelte';
  import { setModalHash } from '../shared/modal-store';

  export let element: HTMLElement = undefined;

  function openUniappModal() {
    setModalHash('uniapp');
  }
</script>

<div
  class="relative z-40 flex justify-center flex-col h-screen pt-[72px] md2:pt-[80px] xl:pt-[104px] md2:flex-row overflow-hidden bg-uniapp-bg-light  md2:gap-8 lg:gap-16 xl:gap-18"
>
  <div
    class="flex flex-col justify-center px-[3rem] pt-[3.5rem] pb-14 md2:pb-0 items-center md2:items-start md2:px-[unset] md2:pt-0"
  >
    <p
      class="text-red text-center opacity-100 text-xxs pb-0 leading-[1.5rem] md2:text-xl md2:leading-10 md2:text-left"
    >
      {$t('WORK.UNIAPP.TITLE')}
    </p>
    <p
      class="text-black text-center opacity-100 text-xxs leading-[1.5rem] md2:text-xl md2:leading-10 md2:text-left w-[262px] xs:w-[266px] sm:w-[328px] md:w-[356px] md2:w-[428px] lg:w-[440px] xl:w-[576px]"
    >
      {$t('WORK.UNIAPP.DESCRIPTION')}
    </p>

    <!-- svelte-ignore a11y-missing-attribute -->
    <a on:click={openUniappModal} class="cursor-pointer mt-6 pb-1 text-[1rem] md2:mb-16 md2:mt-14">
      <Button>
        <span>{$t('WORK.VIEW')}</span>
      </Button></a
    >
  </div>
  <div class="flex md2:flex-grow-0 flex-grow mb-[-7.75rem] justify-center pt-0 md2:pt-14">
    <div
      style="background-image: url('images/uniapp-img1.png'); background-position: top center;"
      class="bg-contain bg-no-repeat h-auto w-[262px] sm:w-[327px] md:w-[356px] md2:w-[361px] lg:w-[500px] xl:w-[594px]"
    />
  </div>
  <span class="absolute bottom-[72px]" bind:this={element} />
</div>
